// extracted by mini-css-extract-plugin
export default {"container":"dropdown-option_container__Uu0x6","label":"dropdown-option_label__vgGSu","center":"dropdown-option_center__fk1Qk","count":"dropdown-option_count__E5JID"};